import { useInactivityDetector } from "./useInactivityDetector";
import { useSipStore } from "@/store/sip";

export interface InactivityHandlerArgs {
  isInCall: boolean;
  reload: () => void;
  resetInactivity: () => void;
}

/**
 * Decide cosa fare allo scadere del timeout di inattività.
 * Estratta come funzione pura per essere testabile senza Vue/Pinia/timer.
 */
export function handleInactivity({
  isInCall,
  reload,
  resetInactivity,
}: InactivityHandlerArgs): void {
  if (isInCall) {
    // Durante una chiamata SIP attiva il reload chiude la sessione WebRTC
    // e termina la chiamata lato carrier. Ri-armiamo il timer invece di ricaricare.
    resetInactivity();
    return;
  }
  reload();
}

/**
 * Wrapper di useInactivityDetector che blocca il reload mentre una chiamata SIP è attiva.
 */
export function useReloadOnInactivity() {
  const sipStore = useSipStore();
  let resetFn: () => void = () => {};

  const detector = useInactivityDetector({
    requireTabHidden: false,
    onInactivity: () =>
      handleInactivity({
        isInCall: sipStore.isInCall,
        reload: () => window.location.reload(),
        resetInactivity: resetFn,
      }),
  });

  resetFn = detector.resetInactivity;

  return detector;
}
